export default __webpack_public_path__ + "static/media/me.b6832d99.jpg";